import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Params } from '@angular/router';
import { IconName } from '../../icons';

@Component({
  selector: 'yat-button-icon',
  templateUrl: './button-icon.component.html',
  styleUrls: ['./button-icon.component.scss']
})
export class ButtonIconComponent {
  @Input()
  id: string;

  @Input()
  isDisabled: boolean = false;

  @Input()
  isMulticolored: boolean = true;

  @Input()
  iconName?: IconName;

  @Input()
  textColor?: string;

  @Input()
  buttonName: string = '';

  @Input()
  queryParams?: Params;

  @Input()
  routerLink?: string;

  @Input()
  position: 'left' | 'middle' | 'right' | null;

  @Input()
  iconSize: 'sm' | 'md' | 'lg' | 'xl' = 'md';

  @Output()
  clickMethod: EventEmitter<void> = new EventEmitter();

  buttonClick(): void {
    this.clickMethod.emit();
  }
}
